import Ajax from '../ajax';

export default {
  list: (data) => Ajax('get', 'otherPoint', data),
  get: (id) => Ajax('get', `otherPoint/${id}`),
  edit: (id, data) => Ajax('put', `otherPoint/${id}`, data),
  enable: (id) => Ajax('put', `otherPoint/${id}/enable`),
  disable: (id) => Ajax('put', `otherPoint/${id}/disable`),

  activityList: (pointId, data) => Ajax('get', `otherPoint/${pointId}/activity`, data),
  activityGet: (pointId, id) => Ajax('get', `otherPoint/${pointId}/activity/${id}`),
  activityCreate: (pointId, data) => Ajax('post', `otherPoint/${pointId}/activity`, data),
  activityEdit: (pointId, id, data) => Ajax('put', `otherPoint/${pointId}/activity/${id}`, data),
  activityDelete: (pointId, id) => Ajax('delete', `otherPoint/${pointId}/activity/${id}`),
};
